export default __webpack_public_path__ + "static/wedropdown-ce40391b2f55820ecb1484bfd6b992bb.png";